import { Injectable } from "@angular/core";
import { AlertController, LoadingController, ToastController } from "@ionic/angular";
import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;


@Injectable()
export class ToolsProvider {

    constructor(
        private _AlertController: AlertController,
        private _ToastController: ToastController,
        private _LoadingController: LoadingController
    ) { }

    async showAlert(title: string, message: string) {
        const alert = await this._AlertController.create({
            cssClass: 'my-custom-class',
            header: title,
            message: message,
            buttons: ['OK']
        });

        await alert.present();
    }

    ShowError(error: any) {
        this.hideLoader();

        console.log(error)
        var err = error.error.type;
        var message = 'Ha ocurrido un error:<br>' + error.message;

        this.showAlert(err, message);
    }

    async saveStorage(key, value): Promise<void> {
        await Storage.set({ key: key, value: JSON.stringify(value) });
    }

    async RemoveStorage(key): Promise<void> {
        Storage.remove({ key: key });
    }

    async viewStorage(key): Promise<any> {
        const item = await Storage.get({ key: key });
        return await JSON.parse(item.value);
    }

    async ShowToast(mensaje: string, duracion: number) {
        console.log('toast')
        const toast = await this._ToastController.create({
            message: mensaje,
            duration: duracion
        });
        toast.present();
    }

    // Show the loader for infinite time
    showLoader() {
        this._LoadingController.create({
            message: 'Please wait...'
        }).then((res) => {
            res.present();
        });
    }

    // Hide the loader if already created otherwise return error
    hideLoader() {
        this._LoadingController.dismiss().then((res) => {
            console.log('Loading dismissed!', res);
            if (res === false) {
                setTimeout(() => {
                    this.hideLoader();
                }, 2000);
            }
            if (res === true) {
                clearTimeout()
            }
        }).catch((error) => {
            setTimeout(() => {
                this.hideLoader();
            }, 2000);
        });
    }

    restrictNumeric(e) {
        let input;
        if (e.metaKey || e.ctrlKey) {
            return true;
        }

        if (e.which === 32) {
            return false;
        }

        if (e.which === 0) {
            return true;
        }

        if (e.which < 33) {
            return true;
        }

        if (e.which === 46) {
            return true;
        }

        input = String.fromCharCode(e.which);
        return !!/[\d\s]/.test(input);
    }

    restricLetras(e) {
        let input = String.fromCharCode(e.which);
        return !!/[a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜÇçÅåÃãâêîìæÆôÿÂãÃðÐÊÎßõÕµþÞÛýÝ\s ´,. ]/.test(input);
    }


    restricEmail(event) {
        if (event.which === 32) {
            return false;
        }

        var regex = new RegExp("^[a-zA-Z@0-9. ]+$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    }


    restricLetrasNumero(event) {
        var regex = new RegExp("^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜÇçÅåÃãâêîìæÆôÿÂãÃðÐÊÎßõÕµþÞÛýÝ# ,-]+$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    }
}